import '../utilities/scrollIntoViewIfNeeded.js';
import { styled, useTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { useMemo, createElement } from 'react';
import '../utilities/ellipsis.js';
import { a as _objectSpread2, _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../ErrorLabel/ErrorLabel.js';
import '../FormItem/FormItem.js';
import '../InputLabel/InputLabel.js';
import InputAddon from '../InputAddon/InputAddon.js';
import 'react-select';
import '../SelectInput/Control.js';
import '../SelectInput/ValueContainer.js';
import '../SelectInput/IndicatorsContainer.js';
import '../SelectInput/DropdownIndicator.js';
import '../SelectInput/ClearIndicator.js';
import '../SelectInput/Menu.js';
import SelectInput from '../SelectInput/SelectInput.js';
import Flags from 'react-phone-number-input/flags';
import { L as filterOptions } from '../utils-58679d3d.js';
import 'react-phone-number-input/input';

const FlagContainer = styled(Div).attrs(props => _objectSpread2({
  flexBasis: '10%'
}, props))`
  .flag {
    width: 40px;
    height: 30px;
  }
`;

const _excluded = ["theme"];
const OptionTextContainer = styled(Div).attrs(_ref => {
  let {
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    flexBasis: '70%',
    marginLeft: `${theme.spacing.md}px`
  }, rest);
})``;

const OptionContainer = styled(Div).attrs(props => _objectSpread2({
  display: 'flex',
  alignItems: 'center'
}, props))``;

const _excluded$1 = ["onChange", "value", "styles", "options"];
const CountrySelect = _ref => {
  let {
      onChange,
      value,
      styles = {},
      options
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  const theme = useTheme();
  const filteredOptions = useMemo(() => filterOptions(options), [options === null || options === void 0 ? void 0 : options.map(({
    label
  }) => label).join(', ')]);
  const customValue = useMemo(() => filteredOptions.find(({
    value: optionValue
  }) => optionValue === value), [filteredOptions, value]);
  return /*#__PURE__*/createElement(InputAddon, {
    position: "start",
    styles: {
      root: {
        top: '1px',
        left: '1px'
      }
    }
  }, /*#__PURE__*/createElement(SelectInput, _extends({
    options: filteredOptions,
    onChange: option => {
      onChange(option.value);
    },
    value: customValue,
    styles: _objectSpread2({
      input: {
        width: '90px',
        height: '48px',
        zIndex: 1,
        border: 'none !important'
      },
      menu: {
        width: '350px',
        left: 0,
        zIndex: 2,
        border: `1px solid ${theme.palette.grey[60]}`
      }
    }, styles.selectInput),
    formatOptionLabel: ({
      value: optionValue,
      label: optionLabel,
      code
    }, {
      context
    }) => {
      var _styles$option, _styles$option2, _styles$option3, _styles$option4, _styles$option5;
      const Flag = Flags[optionValue];
      return context === 'menu' ? /*#__PURE__*/createElement(OptionContainer, (_styles$option = styles.option) === null || _styles$option === void 0 ? void 0 : _styles$option.optionContainer, /*#__PURE__*/createElement(FlagContainer, (_styles$option2 = styles.option) === null || _styles$option2 === void 0 ? void 0 : _styles$option2.flagContainer, /*#__PURE__*/createElement(Flag, {
        title: optionLabel,
        className: "flag"
      })), /*#__PURE__*/createElement(OptionTextContainer, (_styles$option3 = styles.option) === null || _styles$option3 === void 0 ? void 0 : _styles$option3.labelContainer, optionLabel), /*#__PURE__*/createElement(OptionTextContainer, _extends({
        flexBasis: "20%"
      }, (_styles$option4 = styles.option) === null || _styles$option4 === void 0 ? void 0 : _styles$option4.codeContainer), `+${code}`)) : /*#__PURE__*/createElement(FlagContainer, (_styles$option5 = styles.option) === null || _styles$option5 === void 0 ? void 0 : _styles$option5.flagContainer, /*#__PURE__*/createElement(Flag, {
        title: optionLabel,
        className: "flag"
      }));
    }
  }, rest)));
};

export default CountrySelect;
